<template>
  <div class="login-page">
    <div class="container-768">
      <div class="pt-20">
        <h3>権限がないため表示できません</h3>
        <p class="text-left mt-20">
          下記のリンクをクリックして、再度お試し願います。
        </p>
        <p class="text-left mt-20">
          <router-link :to="{name: 'home'}" class="item"
            onclick="document.getElementById('menuopen-input').checked = false"
            >
              <span>トップページへ</span>
          </router-link>
        </p>
      </div>
      <div class="container-370">
      </div>
    </div>
  </div>
</template>

<script>

export default {
  mounted () {
  }
}

</script>



// WEBPACK FOOTER //
// src/pages/NotFound.vue